import { Icon, IconButton } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const RecipientGreetingCardPreviewWrapper = styled.div``;

const RecipientGreetingCardPreviewHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const PreviewHeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
`;

const DeviceWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

const DeviceButton = styled(IconButton)`
  color: var(--color-fg-weaker);

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--color-bg-weaker);
      border: 1px solid var(--color-border-default);
      border-radius: var(--size-border-radius-md);
      color: var(--color-fg-default);
    `}

  &:hover {
    background-color: var(--color-bg-weak);
    border: 1px solid var(--color-border-default);
    border-radius: var(--size-border-radius-md);
  }

  height: 30px;
  transition: none;
  width: 40px;
`;

const RecipientGreetingCardPreviewBodyFrame = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  margin-top: 12px;
`;

const RecipientGreetingCardPreviewBody = styled.div`
  align-items: ${({ selectedCard, isMobile }) =>
    selectedCard && isMobile ? 'flex-start' : 'center'};
  background-image: url(${({ wrapperUrl }) => wrapperUrl});
  background-position: center;
  background-size: contain;
  display: flex;
  height: 550px;
  justify-content: ${({ selectedCard }) => (selectedCard ? 'flex-start' : 'center')};
  padding-left: ${({ selectedCard, isMobile }) => (selectedCard && !isMobile ? '200px' : '0')};
  padding-top: ${({ selectedCard, isMobile }) => (selectedCard && isMobile ? '60px' : '0')};
  position: relative;
  width: 100%;

  ${({ isMobile }) =>
    isMobile &&
    css`
      margin: 0 auto 0 auto;
      width: 422px;
    `}
`;

const RecipientGreetingCardPreviewBodyContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 80px;
  position: relative;
  width: 560px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 16px;
      width: 390px;

      .logo {
        right: 12px;
        top: 12px;
      }
    `}
`;

const UploadImageButtonWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-default);
  border: 2px solid var(--color-fg-weakest3);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: ${({ isMobile }) => (isMobile ? '100px' : '125px')};
  justify-content: center;
  padding: 6px;
  width: ${({ isMobile }) => (isMobile ? '100px' : '125px')};

  ${({ error }) =>
    error &&
    css`
      border: 2px solid var(--color-error-default);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      &,
      ${UploadButton} {
        opacity: 0.4;
      }

      :hover {
        border-color: var(--color-border-default);
      }
    `}
`;

const UploadButton = styled.div`
  align-items: center;
  background-color: transparent;
  border: 2px dashed var(--color-border-strong);
  border-radius: var(--size-border-radius-md);
  color: var(--color-accent-secondary-default);
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;
  height: 100%;
  justify-content: center;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;

  :hover {
    background-color: transparent;
    color: var(--color-accent-secondary-default);
  }
`;

const PreviewItem = styled.div`
  margin-bottom: 24px;
  position: relative;

  &:first-of-type {
    margin-top: 24px;
  }
`;

const PreviewItemIconButton = styled(IconButton)`
  background-color: var(--color-bg-stronger);
  padding: 15px;
  position: absolute;
  right: ${({ right }) => (right ? `${right}px` : 0)};
  top: ${({ top }) => (top ? `${top}px` : 0)};
  z-index: 4;

  ${({ hasError }) =>
    hasError &&
    css`
      background-color: var(--color-error-default);
    `}

  &:hover {
    background-color: var(--color-bg-stronger);
    ${({ hasError }) =>
      hasError &&
      css`
        background-color: var(--color-error-default);
      `}
  }

  ${Icon.S.Icon} {
    fill: var(--color-fg-inverse-default);
  }
`;

const SenderNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export {
  DeviceButton,
  DeviceWrapper,
  PreviewHeaderWrapper,
  PreviewItem,
  PreviewItemIconButton,
  RecipientGreetingCardPreviewBody,
  RecipientGreetingCardPreviewBodyContent,
  RecipientGreetingCardPreviewBodyFrame,
  RecipientGreetingCardPreviewHeader,
  RecipientGreetingCardPreviewWrapper,
  SenderNameWrapper,
  UploadButton,
  UploadImageButtonWrapper
};
